import { Container } from '@backstage/ui';
import { IdentitySettings } from './identity-settings';
import { Page } from '@internal/backstage-plugin-hm-react';

export const UserSettingsLandingPage = () => {
  return (
    <Page title="Settings">
      <Container>
        <IdentitySettings />
      </Container>
    </Page>
  );
};
